import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-7b951af8"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "loan-tab-wrap flex-row"
};
const _hoisted_2 = {
  class: "loan-operate"
};
const _hoisted_3 = ["href"];
const _hoisted_4 = ["href"];
const _hoisted_5 = ["href"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_tab_pane = _resolveComponent("el-tab-pane");
  const _component_el_tabs = _resolveComponent("el-tabs");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_tabs, {
    class: "loan-tabs",
    "model-value": $props.name,
    onTabClick: $setup.handleTab
  }, {
    default: _withCtx(() => [_createVNode(_component_el_tab_pane, {
      label: $setup.t('loan'),
      name: "Loan"
    }, null, 8, ["label"]), _createVNode(_component_el_tab_pane, {
      label: $setup.isLogin ? $setup.t('loan_progress_order_qty', {
        num: $setup.progressOrderQty === -1 ? '-' : $setup.progressOrderQty
      }) : $setup.t('loan_progress_order'),
      name: "Order"
    }, null, 8, ["label"]), _createVNode(_component_el_tab_pane, {
      label: $setup.t('loan_assets_debt'),
      name: "Assets"
    }, null, 8, ["label"]), !$setup.isSub && $setup.isVIP || $setup.userInfo.appliedVipQuota ? (_openBlock(), _createBlock(_component_el_tab_pane, {
      key: 0,
      label: $setup.t('vipLoan1'),
      name: "Vip"
    }, null, 8, ["label"])) : _createCommentVNode("", true)]),
    _: 1
  }, 8, ["model-value", "onTabClick"]), _createElementVNode("p", _hoisted_2, [_createElementVNode("a", {
    href: $setup.orderLink,
    class: _normalizeClass(`${$setup.loanPledge.all_order}`)
  }, _toDisplayString($setup.t('loan_all_order')), 11, _hoisted_3), _createElementVNode("a", {
    href: $setup.announcementLink,
    target: "_blank",
    class: _normalizeClass(`${$setup.loanPledge.all_order}`)
  }, _toDisplayString($setup.t('ltvRatio')), 11, _hoisted_4), _createElementVNode("a", {
    href: "javascript:;",
    onClick: _cache[0] || (_cache[0] = (...args) => _ctx.handleOpenVideo && _ctx.handleOpenVideo(...args))
  }, _toDisplayString($setup.t('loan_video_btn')), 1), _createElementVNode("a", {
    href: $setup.noDmainUrl($setup.replace('/help-center/bybitHC_Article?id=000001771')),
    target: "_blank",
    class: _normalizeClass(`${$setup.loanPledge.user_manual}`)
  }, _toDisplayString($setup.t('loan_user_manual')), 11, _hoisted_5)])]);
}